// extracted by mini-css-extract-plugin
export var chip = "_qw-0";
export var icon = "_qw-1";
export var remove = "_qw-2";
export var removeIcon = "_qw-3";